import axios from '../axios'
import {
    COURSE_LIST_REQUEST, COURSE_LIST_SUCCESS, COURSE_LIST_FAIL,
    COURSE_DETAILS_REQUEST, COURSE_DETAILS_SUCCESS, COURSE_DETAILS_FAIL,
    COURSE_CREATE_REQUEST, COURSE_CREATE_SUCCESS, COURSE_CREATE_FAIL,
    COURSE_UPDATE_REQUEST, COURSE_UPDATE_SUCCESS, COURSE_UPDATE_FAIL,
    COURSE_DELETE_REQUEST, COURSE_DELETE_SUCCESS, COURSE_DELETE_FAIL,
} from '../constants/courseConstants'


const authHeader = (userInfo) => ({
    headers: { Authorization: `Bearer ${userInfo.token}` }
})

const multipartHeader = (userInfo) => ({
    headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'multipart/form-data',
    }
})


export const listCourses = () => async (dispatch, getState) => {
    try {
        dispatch({ type: COURSE_LIST_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.get('/api/courses/', authHeader(userInfo))
        dispatch({ type: COURSE_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: COURSE_LIST_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const getCourseDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: COURSE_DETAILS_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.get(`/api/courses/${id}/`, authHeader(userInfo))
        dispatch({ type: COURSE_DETAILS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: COURSE_DETAILS_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const createCourse = (formData) => async (dispatch, getState) => {
    try {
        dispatch({ type: COURSE_CREATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.post('/api/courses/create/', formData, multipartHeader(userInfo))
        dispatch({ type: COURSE_CREATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: COURSE_CREATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const updateCourse = (id, formData) => async (dispatch, getState) => {
    try {
        dispatch({ type: COURSE_UPDATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.put(`/api/courses/update/${id}/`, formData, multipartHeader(userInfo))
        dispatch({ type: COURSE_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: COURSE_UPDATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const deleteCourse = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: COURSE_DELETE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        await axios.delete(`/api/courses/delete/${id}/`, authHeader(userInfo))
        dispatch({ type: COURSE_DELETE_SUCCESS })
    } catch (error) {
        dispatch({ type: COURSE_DELETE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}
